import classnames from 'classnames';
import React from 'react';

import { CinemaBlogDto } from '@cineamo/api/models/cinema-blog/CinemaBlogDto.types';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

import { IconDown16 } from '@cineamo/ui/src/icons/ic-down';

const CinemaBlogTitleItemDropdown: React.FC<{
    domainConfiguration: DomainConfigurationDto;
    selectedCinemaBlog?: CinemaBlogDto;
    isExpanded: boolean;
    toggleDropdown: () => void;
}> = ({ domainConfiguration, selectedCinemaBlog, isExpanded, toggleDropdown }) => {
    return (
        <button
            id="dropdown-menu"
            className={classnames(
                'flex lg:hidden',
                'w-full h-[40px] flex-row justify-between items-center',
                'px-[9px] border-b-1',
                'cursor-pointer hover:bg-[var(--surface-color)] duration-150',
                'text-body-bold-14'
            )}
            style={{
                borderColor: withOpacity(domainConfiguration.style.onBackgroundColor, 0.2)
            }}
            onClick={toggleDropdown}
            aria-label={`Toggle dropdown: ${selectedCinemaBlog?.title}`}>
            <span>{selectedCinemaBlog?.title}</span>
            <IconDown16 className={classnames('duration-150', isExpanded ? '-rotate-180' : '')} />
        </button>
    );
};

export default CinemaBlogTitleItemDropdown;
